module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_telephone_reserve_gold-ff894d56e71d097290931ff4c368c18d.svg";